<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import qs from 'qs'

export default {
  name: 'app',
  computed: {
    ...mapState('oem', ['oem'])
  },
  methods: {
    ...mapActions('oem', ['find_one']),
    checkOem (route) {
      const query = location.search.substring(1)
      const search = qs.parse(query)
      const oemName = search && search.oem_name
      if (oemName) {
        this.find_one(oemName)
      }
    }
  },
  created () {
    this.checkOem()
  }
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
</style>
